<div [class]="skinName">
  @if (step != 3) {
    <h2 class="uk-modal-title">
    {{ configService.localeKeys?.['common_keys.parental_control.text'] }}</h2>
  }
  @if (step == 3) {
    <h2 class="uk-modal-title">
    {{ responseData.message }}</h2>
  }
  <!-- <div class="parent-subtitle">{{configService.localeKeys?.['common_keys.content_pin.text']}}</div> -->
  @if (step == 1) {
    <div class="step-1">
      <div class="input-container">
        <form [formGroup]="parentalControlForm">
          <div class="d-flex justify-content-space-between align-items-center">
            <div class="switch-label">{{ configService.localeKeys?.['common_keys.parental_control.text'] }}</div>
            <mat-slide-toggle id="parental_enable_toggle" formControlName="is_parental_control_enabled" [disableRipple]="true" (change)="toggleButtonChange($event)">
            </mat-slide-toggle>
          </div>
          <div class="info-text">
            <p class="center-hero-text">{{ configService.localeKeys?.['parental_control.age_limit.text'] }}</p>
            @if (!isParentalButtonOn) {
              <p class="center-descriptor-text agelimit-text">{{ configService.localeKeys?.['parental_control.turn_on_par_control.text']}}</p>
            }
            @if (isParentalButtonOn) {
              <p class="center-descriptor-text agelimit-text">{{ configService.localeKeys?.['parental_control.determine_age_limit.text'] }}</p>
            }
          </div>
          <div class="telescopic-slider-container" [ngClass]="!isParentalButtonOn ? 'disabled-parent-button':'enable-parent-button'">
            <!-- <mat-slider aria-label="unit(s)" [step]="1" [tickInterval]="1" [max]="5" [disabled]="!isParentalButtonOn"></mat-slider> -->
            <div class="placeholder-bar" [ngClass]="{'disabled-bar': !isParentalButtonOn}"></div>
            <div class="active-bar" [ngClass]="{'disabled-active-bar': !isParentalButtonOn}" #activeBarRef></div>
            <mat-radio-group [ngStyle]="{'pointer-events': isParentalButtonOn ? 'all': 'none'}" formControlName="age_limit_value_index" [disabled]="!isParentalButtonOn">
              @for ( limit of parentalControl.age_limits; track  limit; let i = $index) {
                <mat-radio-button [value]="i" [checked]="limit.checked">{{limit.title}}</mat-radio-button>
              }
            </mat-radio-group>
          </div>
          <div class="age-limit-container">
            @if (isParentalButtonOn && parentalControlForm.get('age_limit_value_index').touched && parentalControlForm.get('age_limit_value_index').hasError('required')) {
              <p class="input-placeholder error-block text-center">
                {{configService.localeKeys?.['parental_control.select_age_limit.text']}}
              </p>
            }
            @if (selectedAgeLimit) {
              <p id="age-limit-msg" class="center-descriptor-text" [ngClass]="{'disabled-text': !isParentalButtonOn}">
                {{ configService.localeKeys?.pin_set_for_age_information_part1 }} {{selectedAgeLimit.title}} {{ configService.localeKeys?.['common_keys.contents.text'] }}
              </p>
            }
          </div>
          @if (!isParentalButtonOn) {
            <button type="button" (click)="turnParentalControlOff()" class="uk-button uk-button-default submit-btn">{{  configService.localeKeys?.back_to_account }}</button>
          }
          @if (isParentalButtonOn) {
            <button type="button" (click)="changeToStepTwo()" class="uk-button uk-button-default submit-btn">{{ configService.localeKeys?.['common_keys.next.btn'] }}</button>
          }
        </form>
      </div>
    </div>
  }
  @if (step == 2) {
    <div class="step-2">
      <div class="form-fields input-container">
        <div class="center-hero-text">{{ configService.localeKeys?.['common_keys.content_pin.text'] }}</div>
        @if (parentalControl.is_pin_already_set) {
          <div class="new-pin">{{ configService.localeKeys?.['parental_control.instructions_to_save_or_update_pin.text'] }}</div>
        }
        @if (!parentalControl.is_pin_already_set) {
          <div class="determine-pin">{{ configService.localeKeys?.['parental_control.determine_pin.text'] }} {{selectedAgeLimit.title}} {{ configService.localeKeys?.['common_keys.content.text'] }}</div>
        }
        <div class="otp-container-class margin-otp">
          <input type="password" class="hide-input" autofocus="false">
          @if (loadOTP) {
            <ng-otp-input #ngOtpInput (onInputChange)="onPinChange($event)" [config]="config"></ng-otp-input>
          }
        </div>
        <button type="button" [disabled]="enablePinBtn" (click)="handlePinSubmit()" class="uk-button submit-btn">{{  parentalControl.is_pin_already_set  ? configService.localeKeys?.['common_keys.confirmed.text'] : configService.localeKeys?.['parental_control.activate_parental_control.text'] }}</button>
      </div>
    </div>
  }
  @if (step == 3) {
    <div class="step-3">
      <div class="input-container">
        <app-success icon="/branding/theme/assets/static_assets/ic-check-on-lbg.svg" [closeButtonText]="configService.localeKeys?.['common_keys.ok.text']" [haslottie]="false">
        </app-success>
      </div>
    </div>
  }

</div>